import {useSearchParams} from 'react-router-dom';
import {sha256} from 'js-sha256';
import {Alert, Box} from '@mui/material';
import {setUserToken} from '../../../utils/api';
import Dashboard2 from './Dashboard2';
import Legend from '../components/Legend';

// Only "I. Soddisfazione dei fruitori" remains at Iniziativa level (per-initiative vs sibling
// average); every other FSV Iniziative graph moved to FsvLuoghi to aggregate across the
// project's initiatives.
const DashboardIndex = () => {
    const [searchParams] = useSearchParams();

    const container = searchParams.get('container_id');
    const uoaId = searchParams.get('uoa_id');
    const survey4Id = searchParams.get('survey4_id');
    const hashKey = searchParams.get('key');
    const token = searchParams.get('token');

    const hashKeyLocal = sha256(process.env.REACT_APP_HASH_KEY_FSV || '');

    if (token) {
        setUserToken(token);
    }

    const isAuthorized = !!(
        container &&
        uoaId &&
        survey4Id &&
        hashKey === hashKeyLocal
    );

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    return (
        <Box>
            <Legend />
            <Dashboard2 container={container!} uoaId={uoaId!} surveyId={survey4Id!} />
        </Box>
    );
};

export default DashboardIndex;
